<template>
  <div class="page-main" :style="dataDetailStyle">
    <!--顶部搜索框-->
    <dt-search-bar style="padding: 20px 5px 5px">
      <template slot="filterSlot">
        <data-filter
          ref="dataFilterRef"
          :timeData="$route.params.schoolId != 0 ? schoolTimeData : allTimeData"
          :schoolId="schoolId"
          :filters="filters"
          :timesolt="1"
          :contentObject="contentObject"
          :buttonColor="'#00CAAF'"
          @filter-data="filterData"
        ></data-filter>
      </template>
      <!-- <template slot="addFilterSlot" v-if="$route.params.schoolId != 0">
        <div class="add-select-style">
          <Select
            v-model="listFilters.isActive"
            ref="hwTypeRef"
            filterable
            placeholder="请选择教师的活跃状态"
            @on-change="selectTeaStateChange"
          >
            <Option value="0">全部状态</Option>
            <Option value="1">活跃</Option>
            <Option value="2">不活跃</Option>
          </Select>
        </div>
      </template>
      <template slot="addFilterSlot" v-if="$route.params.schoolId != 0">
        <div class="add-select-style">
          <Select
            v-model="listFilters.adminType"
            ref="hwTypeRef"
            filterable
            placeholder="请选择教师角色"
            @on-change="selectTeaRoleChange"
          >
            <Option value="-1">全部角色</Option>
            <Option
              v-for="item in teaRoleList"
              :value="item.key"
              :key="item.key"
              >{{ item.value }}</Option
            >
          </Select>
        </div>
      </template> -->
      <template slot="buttonSlot">
        <div style="display: flex; float: right">
          <!--搜索框-->
          <div class="big-data-search-input">
            <input
              :placeholder="
                $route.params.schoolId == 0
                  ? '支持学校名称关键字搜索'
                  : '支持教师姓名、手机号关键字搜索'
              "
              class="big-data-input-cla"
              v-model="listFilters.keyWord"
              v-on:keyup.enter="handleSearch"
            />
            <div class="big-data-search-btn" v-on:click="handleSearch">
              <div class="big-data-search-icon">
                <img
                  src="../../../../assets/images/databoard/detailPage/search.png"
                  width="100%"
                  height="100%"
                />
              </div>
            </div>
          </div>
        </div>
      </template>
    </dt-search-bar>
    <div class="table-main-wrap dta-details-table" ref="tableMainRef">
      <div class="table-main">
        <Table
          :columns="
            $route.params.schoolId != 0 ? schoolTeaColumn : totalTeaColumn
          "
          :data="teacherList"
          :row-class-name="rowClassName"
          :loading="isLoading"
        ></Table>
      </div>
      <div class="bottom-page">
        <div class="laypage_main">
          <Page
            :total="pageParams.total"
            @on-change="handleCurrentChange"
            :current="pageParams.page"
            v-if="pageParams.total && pageParams.pageCount > 1"
            show-total
          ></Page>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  findTeacherList,
  findTotalBySchool,
} from "../../../../service/bigDataApi.js";

const DtSearchBar = () => import("../../../../components/DtSearchBar");
const DataFilter = () => import("../../../../components/DataFilter");
export default {
  name: "teacher-list",
  components: {
    DtSearchBar,
    DataFilter,
  },
  watch: {
    "listFilters.keyWord": {
      handler(newValue, oldValue) {
        this.handleSearch();
      },
      deep: true,
    },
  },
  data() {
    return {
      //加载中
      isLoading: true,
      //各校时间切换按钮
      schoolTimeData: [
        {
          key: 0,
          value: "全部",
        },
        {
          key: 1,
          value: "近一周",
        },
        {
          key: 2,
          value: "近一月",
        },
        {
          key: 3,
          value: "自定义",
        },
      ],
      //总时间切换按钮
      allTimeData: [
        {
          key: 0,
          value: "全部",
        },
        {
          key: 1,
          value: "近一周",
        },
        {
          key: 2,
          value: "近一月",
        },
        {
          key: 4,
          value: "近三月",
        },
      ],
      //教师角色类型
      teaRoleList: [
        {
          key: 0,
          value: "普通教师",
        },
        {
          key: 1,
          value: "总管理员",
        },
        {
          key: 2,
          value: "校级管理员",
        },
        {
          key: 3,
          value: "班级管理员",
        },
      ],
      teacherList: [],
      schoolId:
        this.$route.params.schoolId == 0 ? "" : this.$route.params.schoolId,
      listFilters: {
        keyWord: "",
        isActive: "0",
        adminType: "-1",
      },
      dataDetailStyle: {
        height: "850px",
      },
      filters: {},
      pageParams: {
        page: 1,
        limit: 10,
        total: 0,
        pageCount: 0,
      },
      //动态配置搜索框中的组件是否显示
      contentObject: {
        //是否显示时间切换按钮
        displayTimeFilter: true,
        //是否显示学科下拉框
        displaySubjectFilter: this.$route.params.schoolId != 0 ? true : false,
        //是否显示年级下拉框
        displayGradeFilter: false,
        //是否显示班级下拉框
        displayClassFilter: false,
        //是否显示学年下拉框
        displayYearFilter: false,
        //是否显示省份下拉框
        displayProvinceFilter: this.$route.params.schoolId == 0 ? true : false,
        //是否显示城市下拉框
        displayCityFilter: this.$route.params.schoolId == 0 ? true : false,
        //是否显示地区下拉框
        displayDistrictFilter: this.$route.params.schoolId == 0 ? true : false,
      },
      //各校的教师列表列
      schoolTeaColumn: [
        {
          title: "教师姓名",
          key: "full_name",
          render: (h, params) => {
            return h("div", [
              h(
                "a",
                {
                  attrs: {
                    title: "点击查看教师详情",
                    href: "javascript:void(0);",
                  },
                  style: {
                    color: "#0199ff",
                    fontSize: "14px",
                  },
                  on: {
                    click: () => {
                      this.lookTeaDetails(params.row);
                    },
                  },
                },
                params.row.full_name
              ),
            ]);
          },
        },
        {
          title: "手机号",
          key: "mobile",
          render: (h, params) => {
            if (params.row.mobile) {
              return h("div", [
                h(
                  "span",
                  params.row.mobile.substring(0, 3) +
                    "****" +
                    params.row.mobile.substring(
                      params.row.mobile.length - 4,
                      params.row.mobile.length
                    )
                ),
              ]);
            } else {
              return h("div", [h("span", params.row.mobile)]);
            }
          },
        },
        {
          title: "所授学科",
          key: "subject_name",
        },
        {
          title: "角色",
          key: "admin_type",
          render: (h, params) => {
            if (params.row.admin_type == 0) {
              return h("div", "普通教师");
            } else if (params.row.admin_type == 1) {
              return h("div", "总管理员");
            } else if (params.row.admin_type == 2) {
              return h("div", "校级管理员");
            } else if (params.row.admin_type == 3) {
              return h("div", "班级管理员");
            }
          },
        },
        {
          title: "使用天数",
          key: "usage_date",
          renderHeader: (h, params) => {
            return h(
              "div",
              {
                attrs: {
                  class: "sort-col",
                },
                on: {
                  click: () => {
                    this.sortData("usage_date");
                  },
                },
              },
              [
                h(
                  "span",
                  {
                    style: {
                      cursor: "pointer",
                    },
                  },
                  "使用天数"
                ),
                h("img", {
                  attrs: {
                    class: "sort-fun",
                    src: "/icon_change.png",
                  },
                  style: {
                    cursor: "pointer",
                  },
                }),
              ]
            );
          },
        },
      ],
      //全部教师列表列
      totalTeaColumn: [
        {
          title: "省级行政区",
          key: "province_name",
        },
        {
          title: "市级行政区",
          key: "city_name",
        },
        {
          title: "所属区域",
          key: "district_name",
        },
        {
          title: "学校名称",
          key: "school_name",
          render: (h, params) => {
            return h("div", [
              h(
                "a",
                {
                  attrs: {
                    title: "点击查看各校数据展板",
                    href: "javascript:void(0);",
                  },
                  style: {
                    color: "#0199ff",
                    fontSize: "14px",
                  },
                  on: {
                    click: () => {
                      this.lookSchoolDataBoard(params.row);
                    },
                  },
                },
                params.row.school_name
              ),
            ]);
          },
        },
        {
          title: "使用教师数",
          key: "use_tea_num",
          renderHeader: (h, params) => {
            return h(
              "div",
              {
                attrs: {
                  class: "sort-col",
                },
                on: {
                  click: () => {
                    this.sortData("use_tea_num");
                  },
                },
              },
              [
                h(
                  "span",
                  {
                    style: {
                      cursor: "pointer",
                    },
                  },
                  "使用教师数"
                ),
                h("img", {
                  attrs: {
                    class: "sort-fun",
                    src: "/icon_change.png",
                  },
                  style: {
                    cursor: "pointer",
                  },
                }),
              ]
            );
          },
        },
        {
          title: "教师总数",
          key: "tea_num",
          renderHeader: (h, params) => {
            return h(
              "div",
              {
                attrs: {
                  class: "sort-col",
                },
                on: {
                  click: () => {
                    this.sortData("tea_num");
                  },
                },
              },
              [
                h(
                  "span",
                  {
                    style: {
                      cursor: "pointer",
                    },
                  },
                  "教师总数"
                ),
                h("img", {
                  attrs: {
                    class: "sort-fun",
                    src: "/icon_change.png",
                  },
                  style: {
                    cursor: "pointer",
                  },
                }),
              ]
            );
          },
        },
      ],
      //各校教师列表排序参数
      schoolTeaDataSortArr: [
        {
          sortType: "usage_date",
          orderType: "desc",
        },
      ],
      //全部教师列表排序参数
      tolTeaDataSortArr: [
        {
          sortType: "use_tea_num",
          orderType: "desc",
        },
        {
          sortType: "tea_num",
          orderType: "desc",
        },
      ],
      schoolTeaDataOrder: "usage_date desc",
      tolTeaDataOrder: "use_tea_num desc",
    };
  },
  methods: {
    /**
     * 筛选数据
     */
    filterData(filters, searchHeight) {
      this.pageParams.page = 1;
      this.isLoading = true;
      this.filters = filters;
      this.searchHeight = searchHeight;
      this.queryTeaDataBySchoolCode();
    },
    /**
     * 切换教师状态
     */
    selectTeaStateChange(val) {
      this.pageParams.page = 1;
      this.isLoading = true;
      this.filters.isActive = val == undefined || val == "" ? "0" : val;
      this.getTeacherList();
    },
    /**
     * 切换教师角色
     */
    selectTeaRoleChange(val) {
      this.pageParams.page = 1;
      this.isLoading = true;
      this.filters.adminType = val == undefined || val == "" ? "-1" : val;
      this.queryTeaDataBySchoolCode();
    },
    /**
     * 获取教师列表
     */
    async getTeacherList() {
      let _this = this;
      let params = {
        schoolid: _this.schoolId,
        keyword: _this.listFilters.keyWord,
        startdate: _this.filters.startDate,
        enddate: _this.filters.endDate,
        schoolyear: _this.filters.classyear,
        pageno: _this.pageParams.page,
        pagesize: _this.pageParams.limit,
        subjectid: _this.filters.subjectId == 0 ? "" : _this.filters.subjectId,
        gradeid: _this.filters.gradeId == 0 ? (_this.filters.phaseGradeIds || "") : _this.filters.gradeId,
        classid: _this.filters.classId == 0 ? "" : _this.filters.classId,
        isactive:
          _this.listFilters.isActive == "" ? "0" : _this.listFilters.isActive,
        admintype:
          _this.listFilters.adminType == "-1"
            ? ""
            : _this.listFilters.adminType,
        order: _this.schoolTeaDataOrder,
        timeType:_this.filters.timeSolt
      };
      let resultData = await findTeacherList(params).catch(function (error) {
        _this.$Message.error(error.message);
      });
      _this.isLoading = false;
      _this.teacherList = [];
      _this.pageParams.total = 0;
      if (Object.keys(resultData).length > 0) {
        _this.teacherList = resultData.rows;
        _this.pageParams.total = resultData.total_rows;
        _this.pageParams.pageCount = resultData.page_count;
        _this.$nextTick(() => {
          _this.dataDetailStyle.height =
            _this.searchHeight +
            _this.$refs.tableMainRef.clientHeight +
            30 +
            "px";
        });
      }
    },
    /**
     * 获取总教师列表
     */
    async getTotalBySchool() {
      let _this = this;
      let params = {
        schoolid: _this.schoolId,
        keyword: _this.listFilters.keyWord,
        pageno: _this.pageParams.page,
        pagesize: _this.pageParams.limit,
        type:
          _this.filters.timeSolt == 4
            ? 3
            : _this.filters.timeSolt == 0
            ? ""
            : _this.filters.timeSolt,
        provinceId:
          _this.filters.provinceId == "0" ? "" : _this.filters.provinceId,
        cityId: _this.filters.cityId == "0" ? "" : _this.filters.cityId,
        districtId:
          _this.filters.districtId == "0" ? "" : _this.filters.districtId,
        order: _this.tolTeaDataOrder,
      };
      let resultData = await findTotalBySchool(params).catch(function (error) {
        _this.$Message.error(error.message);
      });
      _this.isLoading = false;
      _this.teacherList = [];
      _this.pageParams.total = 0;
      if (Object.keys(resultData).length > 0) {
        _this.teacherList = resultData.rows;
        _this.pageParams.total = resultData.total_rows;
        _this.pageParams.pageCount = resultData.page_count;
        _this.$nextTick(() => {
          _this.dataDetailStyle.height =
            _this.searchHeight +
            _this.$refs.tableMainRef.clientHeight +
            30 +
            "px";
        });
      }
    },
    /**
     * 翻页
     */
    handleCurrentChange(val) {
      this.isLoading = true;
      this.pageParams.page = val;
      this.queryTeaDataBySchoolCode();
    },
    /**
     * 查询
     */
    handleSearch() {
      this.isLoading = true;
      this.pageParams.total = 0;
      this.pageParams.page = 1;
      this.pageParams.pageCount = 0;
      this.queryTeaDataBySchoolCode();
    },
    /**
     * 查看各校的数据展板
     */
    lookSchoolDataBoard(rows) {
      let routeData = this.$router.resolve({
        name:
          rows.school_id == "75047a8a0990480f8abf3a39bc25f1ab"
            ? "cloudschooldataboard"
            : "schooldataboard",
        params: {
          schoolId: rows.school_id,
        },
        query: {
          tokenId: this.$store.getters.token,
        },
      });
      window.open(routeData.href, "_blank");
    },
    /**
     * 排序
     */
    sortData(sortType) {
      let data = [];
      if (this.$route.params.schoolId != 0) {
        data = this.schoolTeaDataSortArr;
      } else {
        data = this.tolTeaDataSortArr;
      }
      for (let i = 0; i < data.length; i++) {
        if (data[i].sortType == sortType) {
          data[i].orderType = data[i].orderType == "desc" ? "asc" : "desc";
          if (this.$route.params.schoolId != 0) {
            this.schoolTeaDataOrder =
              data[i].sortType + " " + data[i].orderType;
          } else {
            this.tolTeaDataOrder = data[i].sortType + " " + data[i].orderType;
          }
        }
      }
      this.pageParams.page = 1;
      this.queryTeaDataBySchoolCode();
    },
    /**
     * 表格斑马纹
     */
    rowClassName(row, index) {
      if (index % 2 == 0) {
        return "ivu-table-stripe-even";
      } else return "ivu-table-stripe-odd";
    },
    /**
     * 根据情况请求不同的班级列表数据
     */
    queryTeaDataBySchoolCode() {
      if (this.$route.params.schoolId != 0) {
        this.getTeacherList();
      } else {
        this.getTotalBySchool();
      }
    },
    /**
     * 点击查看教师详细数据
     */
    lookTeaDetails(rows) {
      // let routeData = this.$router.resolve({
      //     name: "teacheruserpro",
      //     query: {
      //         schoolId: this.schoolId,
      //         schoolName: this.$route.params.schoolName,
      //         teaName: rows.full_name,
      //         userId: rows.userId,
      //         timeSolt: this.filters.timeSolt,
      //         startDate: this.filters.startDate,//本页面选择的开始时间
      //         endDate: this.filters.endDate//本页面选择的结束时间
      //     }
      // });
      // window.open(routeData.href, "_blank");
      this.$router.push({
        name: "teacheruserpro",
        query: {
          schoolId: this.schoolId,
          schoolName: this.$route.params.schoolName,
          teaName: rows.full_name,
          userId: rows.userId,
          timeSolt: this.filters.timeSolt,
          startDate: this.filters.startDate, //本页面选择的开始时间
          endDate: this.filters.endDate, //本页面选择的结束时间
        },
      });
    },
    /**
     * 面包屑
     */
    setCurrentPath() {
      let currentPathArr;
      currentPathArr = [
        {
          title: "首页",
          path:
            this.$route.params.schoolId == "75047a8a0990480f8abf3a39bc25f1ab"
              ? "cloudschooldataboard"
              : "schooldataboard",
          name:
            this.$route.params.schoolId == "75047a8a0990480f8abf3a39bc25f1ab"
              ? "cloudschooldataboard"
              : "schooldataboard",
          params: {
            schoolId: this.$route.params.schoolId,
          },
          query: {
            tokenId: this.$store.getters.token,
          },
        },
        {
          title: this.$route.params.schoolName,
          path: "",
          name: "schoolName",
        },
        {
          title: "全部教师",
          path: "",
          name: "teacherList",
        },
      ];
      this.$store.commit("setCurrentPath", currentPathArr);
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.setCurrentPath();
    });
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import "../../../../style/detailPage";

.table-main-wrap {
  margin-top: 10px !important;
}

.big-data-search-btn {
  background: #00caaf !important;
  color: #fff;
  border-color: #00caaf !important;
}
</style>
<style lang="scss">
.table-main {
  /*偶数行*/
  .ivu-table-stripe-even td {
    background-color: #fff !important;
  }

  /*奇数行*/
  .ivu-table-stripe-odd td {
    background-color: #fafbfd !important;
  }

  .ivu-table th {
    background-color: #f3f7f6;
    height: 50px !important;
    font-weight: bold;
  }
  .ivu-table td,
  .ivu-table th {
    border-bottom: 0;
  }
  .ivu-table:before {
    background-color: #efefef !important;
  }
  .ivu-table:after {
    background-color: #efefef !important;
  }
  .ivu-table-wrapper {
    border-top: 1px solid #efefef;
    border-left: 1px solid #efefef;
  }
}
</style>
